module.exports = "/assets/data/0cc5a7e5c81f1f913876161daba5648d-CM11.data.json";